module.exports = __webpack_public_path__ + "img/login_signup13.b270cb7d.png";